import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * AuthenticatedRoute - Route guard pro přístup k aplikaci
 * 
 * Umožňuje přístup pouze:
 * 1. Admin účtům (role === 'admin')
 * 2. Schváleným demo testovacím účtům (role === 'demo_tester')
 * 3. Běžným uživatelům (role === 'user')
 * 4. Školním žákům (role === 'student_school') - přesměruje do kontextu jejich učebny
 * 5. Učitelům (role === 'teacher') - přesměruje do kontextu jejich učebny
 * 
 * Nepřihlášení uživatelé jsou přesměrováni na landing page (/)
 */
export default function AuthenticatedRoute({ children }) {
  const { current } = useAuth();
  const location = useLocation();

  // Pokud není přihlášen, přesměruj na landing page
  if (!current) {
    return <Navigate to="/" replace />;
  }

  // Pro školní účty (student_school nebo teacher) - přesměruj do kontextu učebny
  // POUZE pokud se uživatel pokouší dostat na dashboard nebo jiné hlavní stránky
  // Nedělej redirect, pokud už je na školní stránce
  if (
    (current.role === 'student_school' || current.role === 'teacher') && 
    current.classroom_code && 
    !location.pathname.startsWith('/skola/')
  ) {
    return <Navigate to={`/skola/${current.classroom_code}`} replace />;
  }

  return children;
}
